import { render, staticRenderFns } from "./WorkflowCreate.vue?vue&type=template&id=4c4ea496"
import script from "./WorkflowCreate.vue?vue&type=script&setup=true&lang=ts"
export * from "./WorkflowCreate.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports